import React, { useContext, useEffect, useState } from 'react'
import listApi from '../../services/api';
import { AuthContext } from '../../context/AuthContext';
import { Button, Card, message, Modal, notification, Select, Table } from 'antd';
import { ReloadOutlined } from "@ant-design/icons";

export default function VoucherManagement() {
  const { userData } = useContext(AuthContext);
  const [listVoucher, setListVoucher] = useState([])
  const [loading, setLoading] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [listUser, setListUser] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);

  useEffect(() => {
    fetchListVoucher();
    fetchListUser();
  }, [])

  
  const columns = [
    {
      title: 'ID',
      dataIndex: 'ID',
      key: 'ID',
    },
    {
      title: 'Mã Voucher',
      dataIndex: 'VoucherCode',
      key: 'VoucherCode',
    },
    {
      title: 'Giảm giá (%)',
      dataIndex: 'discount',
      key: 'discount',
    },
    {
      title: 'Thời gian bắt đầu',
      dataIndex: 'starting_time',
      key: 'starting_time',
    },
    {
      title: 'Thời gian kết thúc',
      dataIndex: 'end_time',
      key: 'end_time',
    },
    {
      title: 'Trạng thái',
      dataIndex: 'voucher_state',
      key: 'voucher_state',
    },
    
    {
      title: 'Hành động',
      key: 'action',
      render: (text, record) => (
        record.voucher_state === 'Đã hết hạn' ? (
          <Button type="primary" disabled>
            Đã gán
          </Button>
        ) : (
          <Button type="primary" onClick={() => handleAssignVoucher(record)}>
            Gán Voucher
          </Button>
        )
      ),
    },


  ];

  const handleAssignVoucher = (voucher) => {
    setSelectedVoucher(voucher);
    setIsModalVisible(true);
  };


  const fetchListUser = async () => {
    setLoading(true)
    try {
      const response = await fetch(listApi.listUser, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          session_id: userData.session_id,
        })
      });
      const data = await response.json();
      console.log("Check data voucher----->", data)
      if (data.code === 200) {
        setLoading(false)
        setListUser(data.list_user || []);
      }
    } catch (error) {
      setLoading(false)
      console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
    }
  };

  
  const fetchListVoucher = async () => {
    setLoading(true)
    try {
      const response = await fetch(listApi.listVoucherSealTime, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          session_id: userData.session_id,
          sale_name:"test đợt"
        })
      });
      const data = await response.json();
      console.log("Check data voucher----->", data)
      if (data.code === 200) {
        setLoading(false)
        setListVoucher(data.list_voucher);
      }
    } catch (error) {
      setLoading(false)
      console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
    }
  };

  const handleOk = async () => {
    try {
      const response = await fetch(listApi.addVoucherToUser, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          session_id: userData.session_id,
          voucher_id: selectedVoucher.ID,
          user_id: selectedUserId
        })
      });
      const data = await response.json();
      console.log("Check data assign voucher----->", data)
      if (data.code === 200) {
        
        notification.success({
          message: 'Thành công',
          description: 'Gán voucher thành công',
          placement: 'topRight',
        });

        setIsModalVisible(false);
        setSelectedUserId(null);
        fetchListVoucher();
      } 
      else{
        notification.error("Gán voucher thất bại")
      }
    } catch (error) {
      notification.error("Lỗi khi gán voucher")
      console.error("Lỗi khi gán voucher:", error);
    }
  };

  
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedUserId(null);
  };



  return (
    <Card
    title="📊QUẢN LÝ ƯU ĐÃI"
    extra={
        <>
            <Button 
                loading={loading}
                onClick={fetchListVoucher}
                icon={<ReloadOutlined />} 
                style={{ marginRight: "10px" }}>
                    Tải Lại
            </Button>
        </>
    }
    style={{ marginBottom: "20px", }}
>
  <Table loading={loading} columns={columns} dataSource={listVoucher} pagination={{ pageSize: 10}} />
  <Modal
        title="Gán Voucher cho người dùng"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Select
          placeholder="Chọn người dùng"
          style={{ width: '100%' }}
          value={selectedUserId}
          onChange={(value) => setSelectedUserId(value)}
        >
          {listUser.map(user => (
            <Select.Option key={user.id} value={user.id}>
              {user.full_name} ({user.username})
            </Select.Option>
          ))}
        </Select>
      </Modal> 
</Card>


  )
}
